module.exports = __webpack_public_path__ + "static/media/icon_expired_filter.bdc31b98.svg";